import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      minHeight: '100%',

      backgroundSize: 'cover',
      backgroundColor: theme.mode === 'dark' ? '#000' : '#e8e8e8d9',
      backgroundAttachment: 'fixed',
      '&:before': {
        content: '""',
        position: 'absolute'
      }
    },
    activeIcon: {
      color: `${theme.palette?.primary.main} !important`
    },
    container: {
      minHeight: '100%',
      height: '100%'
    },
    searchContainer: {
      display: 'flex',
      minHeight: '100vh',
      [theme.breakpoints?.up('sm')]: {
        flexDirection: 'row'
      },
      [theme.breakpoints?.down('sm')]: {
        flexDirection: 'column-reverse'
      }
    },
    miniMapSide: {
      [theme.breakpoints?.down('lg')]: {
        width: 300
      },
      [theme.breakpoints?.up('lg')]: {
        width: 400
      },
      [theme.breakpoints?.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints?.down('sm')]: {
        opacity: 0,
        zIndex: -1
      },
      // width: 400,
      marginRight: 30,
      marginTop: 65
    },
    listSide: {
      [theme.breakpoints?.down('lg')]: {
        width: 'calc(100% - 300px)'
      },
      [theme.breakpoints?.up('lg')]: {
        width: 'calc(100% - 400px)'
      },

      [theme.breakpoints?.down('md')]: {
        width: '100%'
      },
      [theme.breakpoints?.down('sm')]: {
        width: 'calc(100% - 120px)',
        paddingRight: 30,
        paddingLeft: 90,
        paddingTop: 0
      },

      [theme.breakpoints?.up('sm')]: {

        paddingRight: 30,
        paddingLeft: 102,
        paddingTop: 102
      }

    },

    showMapSide: {
      opacity: 1,
      zIndex: 1
    },
    hiddenListSide: {
      display: 'none'
    },

    btnGroup: {
      marginLeft: '16px !important',
      '&>svg': {
        color: 'gray' + ' !important'
      }
    },

    formContainer: {
      maxWidth: 900,
      display: 'inline-block',
      padding: 30
    },

    contentPaginator: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '30px 0'
    }
  }
)

const PREFIX = 'SearchStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const SearchStyle = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  SearchStyle
}
